import React from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';

interface MessageSnackbarProps {
  open: boolean;
  message: string | null;
  severity?: AlertColor;
  autoHideDuration?: number;
  onClose: () => void;
  anchorOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
}

const MessageSnackbar: React.FC<MessageSnackbarProps> = ({
  open,
  message,
  severity = 'error',
  autoHideDuration = 6000,
  onClose,
  anchorOrigin = { vertical: 'top', horizontal: 'center' },
}) => {
  if (!message) return null;

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          maxWidth: 560,
          fontWeight: 500,
          whiteSpace: message.includes('\n') ? 'pre-line' : undefined,
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MessageSnackbar; 